import {mapTradeTagDbToType, TradeTag} from '@cp/model';
import {getDocs} from 'firebase/firestore';
import {getCurrentUserIdValidated} from '../../config/firebase';
import {getTradeTagsCollection} from './getTradeTagsCollection';

export async function listTradeTags(): Promise<TradeTag[]> {
  const uid = await getCurrentUserIdValidated();
  const colRef = getTradeTagsCollection(uid);
  const snapshot = await getDocs(colRef);
  return snapshot.docs.map((d) => mapTradeTagDbToType(d));
}
